import React from "react";
import Navbar from "../../navbar/Navbar";
import "./home.css"
import Whyvits from "./Whyvits";
import Footer from "..//../footer/Footer"
import Placement from "./Placement";
import Admission from "./Admission";
import Experience from "./Experience";
import { useEffect, useRef } from 'react';
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import Testimonial from "./Testimonial"
gsap.registerPlugin(ScrollTrigger);
function Home() {
  return (
    <>
      <Navbar />
      <div className="home_container">
        <div className="landing_page">
          <img src="https://wallpapercave.com/wp/wp2468660.jpg" alt="" />
        </div>
        <div className="sliding_text">
          <span>Notification</span>
          <marquee behavior="" direction="left" scrollamount="7">
            This is made by Atul rajak,manish verma and ankit pal and guided by Neeraj sharma sir.. &copy; 2024
          </marquee>
        </div>
      </div>
        <Whyvits/>
        <Experience/>
        <Admission/>
        <Placement/>
        {/* <Testimonial/> */}
        <Footer/>
    </>
  );
}

export default Home;
